<template>
    <div class="title-wrap">
        <h1 class="title" :class="{ 'marginbottom10': !!description }">
            {{ title }}

            <b-tag type="is-dark" size="is-medium" v-if="!_.isNull(total) || !!loading">
                <font-awesome-icon v-if="loading" :icon="['fas', 'spinner']" spin/>
                <span v-else>{{ number_format(total, 0) }}</span>
            </b-tag>
        </h1>

        <p v-if="description" class="description">
            {{ description }}
        </p>
    </div>
</template>

<script>
import formatMixin from '@/mixins/formatMixins'

export default {
    name: 'PageTitle',

    mixins: [formatMixin],

    props: {
        title: {
            type: String,
            required: true
        },
        total: {
            type: Number,
            default: null
        },
        loading: {
            type: Boolean,
            default: false
        },
        description: {
            type: String,
            default: null
        }
    }
}
</script>